export const modelsLocalization = new Map([
  ['Conversions', $localize`:@@common.conversions:Conversions`],
  ['Earning', $localize`:@@finance.earning:Earning`],
  ['Transactions', $localize`:@@common.transactions:Transactions`],
  ['Clicks', $localize`:@@common.clicks:Clicks`],
  ['Invoices', $localize`:@@common.invoices:Invoices`],
  ['Click-Conversion', $localize`:@@common.click_conversion:Click-Conversion`],
]);

export const aggregateLocalization = new Map([
  ['Sum', $localize`:@@settings.aggregate_sum:Sum`],
  ['Count', $localize`:@@settings.aggregate_count:Count`],
  ['Minimum', $localize`:@@settings.aggregate_minimum:Minimum`],
  ['Maximum', $localize`:@@settings.aggregate_maximum:Maximum`],
]);

export const signsLocalization = new Map([
  ['Equal', $localize`:@@common.equal:Equal`],
  ['Not Equal', $localize`:@@common.not_equal:Not Equal`],
  ['Less Or Equal', $localize`:@@common.less_or_equal:Less Or Equal`],
  ['Less', $localize`:@@common.less:Less`],
  ['Greater', $localize`:@@common.greater:Greater`],
  ['Greater Or Equal', $localize`:@@common.greater_or_equal:Greater Or Equal`],
]);

export const formatLocalization = new Map([
  ['Boolean', $localize`:@@common.boolean:Boolean`],
  ['Float', $localize`:@@common.float:Float`],
  ['Number', $localize`:@@common.number:Number`],
  ['Money', $localize`:@@common.money:Money`],
  ['Percentage', $localize`:@@common.percentage:Percentage`],
]);

export const dateTypeLocalization = new Map([
  ['Created At', $localize`:@@common.created_at:Created At`],
  ['Afm Date', $localize`:@@common.afm_date:AFM Date`],
  ['Transaction Date', $localize`:@@common.transaction_date:Transaction Date`],
  ['From To', $localize`:@@common.from_to:From To`],
]);

export const targetsLocalization = new Map([
  ['Clicks', $localize`:@@common.clicks:Clicks`],
  ['All Conversions', $localize`:@@common.all_conversions:All Conversions`],
  ['Payout Amount', $localize`:@@common.payout_amount:Payout Amount`],
  ['Revenue Amount', $localize`:@@common.revenue_amount:Revenue Amount`],
  ['Deposit Amount', $localize`:@@common.deposit_amount:Deposit Amount`],
  ['Withdrawal Amount', $localize`:@@common.withdrawal_amount:Withdrawal Amount`],
  ['Bet Amount', $localize`:@@common.bet_amount:Bet Amount`],
  ['Win Amount', $localize`:@@common.win_amount:Win Amount`],
  ['Net Gaming Amount', $localize`:@@common.net_gaming_amount:Net Gaming Amount`],
  ['Chargeback Amount', $localize`:@@common.chargeback_amount:Chargeback Amount`],
  ['Bonus Cash Amount', $localize`:@@common.bonus_cash_amount:Bonus Cash Amount`],
  ['Net Gaming Cash Amount', $localize`:@@common.net_gaming_cash_amount:Net Gaming Cash Amount`],
  ['Wagered Bonus Amount', $localize`:@@common.wagered_bonus_amount:Wagered Bonus Amount`],
  ['Fee Amount', $localize`:@@common.fee_amount:Fee Amount`],
  ['Invoices', $localize`:@@common.invoices:Invoices`],
  ['Total', $localize`:@@common.total:Total`],
  ['Total Paid', $localize`:@@common.total_paid:Total Paid`],
  ['Transactions', $localize`:@@common.transactions:Transactions`],
  ['Transactions Amount', $localize`:@@common.transactions_amount:Transactions Amount`],
  ['Click ID', $localize`:@@common.click_id:Click ID`],
]);

export const formatsTranslations = {
  Boolean: $localize`:@@common.boolean:Boolean`,
  Float: $localize`:@@common.float:Float`,
  Number: $localize`:@@common.number:Number`,
  Money: $localize`:@@common.money:Money`,
  Percentage: $localize`:@@common.percentage:Percentage`,
};
